const DE = {
  associationIncorporated: [
    "eingetragener Verein (e.V.)",
    "eingetragene Genossenschaft (eG)",
    "wirtschaftlicher Verein"
  ],
  partnershipIncorporated: [
    "Partnerschaftsgesellschaft (PartG)",
    "GmbH & Co. KG"
  ],
  partnershipUnincorporated: [
    "GmbH & Co. OHG",
    "offene Handelsgesellschaft (OHG)",
    "Gesellschaft des bürgerlichen Rechts (GbR)"
  ]
};
export {
  DE as default
};
